import { AnimatedSection } from './AnimatedSection';

export const SectionHeader = ({ 
  label, 
  title, 
  description, 
  align = 'center',
  className = '' 
}) => {
  const alignClasses = {
    center: 'text-center mx-auto',
    left: 'text-left',
  };

  return (
    <AnimatedSection className={`max-w-3xl ${alignClasses[align]} ${className}`}>
      {label && (
        <span className="inline-block px-4 py-1.5 bg-sky-50 dark:bg-sky-900/50 text-sky-600 dark:text-sky-300 text-sm font-semibold rounded-full mb-4">
          {label}
        </span>
      )}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white mb-4 tracking-tight">
        {title}
      </h2>
      {description && (
        <p className="text-base lg:text-lg text-slate-600 dark:text-slate-300 leading-relaxed">
          {description}
        </p>
      )}
    </AnimatedSection>
  );
};

export const PageHeader = ({ 
  label, 
  title, 
  description,
  backgroundImage
}) => {
  return (
    <section 
      className="relative py-20 lg:py-32 bg-gradient-to-br from-slate-50 to-sky-50 dark:from-slate-900 dark:to-slate-800 overflow-hidden"
      data-testid="page-header"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-grid opacity-50 dark:opacity-20" />
      
      {/* Optional Background Image */}
      {backgroundImage && (
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      )}

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection className="max-w-3xl">
          {label && (
            <span className="inline-block px-4 py-1.5 bg-sky-100 dark:bg-sky-900/50 text-sky-700 dark:text-sky-300 text-sm font-semibold rounded-full mb-6">
              {label}
            </span>
          )}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 dark:text-white mb-6 tracking-tight">
            {title}
          </h1>
          {description && (
            <p className="text-lg lg:text-xl text-slate-600 dark:text-slate-300 leading-relaxed">
              {description}
            </p>
          )}
        </AnimatedSection>
      </div>
    </section>
  );
};
